module.exports = __webpack_public_path__ + "img/lacrosse-stick-ball.0fd8a8d7.svg";